var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRfqCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.334 0H5.665C2.26743 0 0 2.4326 0 5.916V14.084C0 17.5707 2.26137 20 5.665 20H14.333C17.7376 20 20 17.5707 20 14.084V5.916C20 2.4295 17.7378 0 14.334 0Z",
    fill: "#009CA6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0291 7.09467C13.322 6.80178 13.7969 6.80178 14.0898 7.09467C14.3561 7.36094 14.3803 7.7776 14.1624 8.07121L14.0898 8.15533L9.34378 12.9013C9.07756 13.1676 8.66097 13.1918 8.36736 12.974L8.28323 12.9014L5.90923 10.5284C5.61628 10.2356 5.61618 9.76074 5.90901 9.46778C6.17522 9.20146 6.59188 9.17717 6.88554 9.39496L6.96967 9.46756L8.81255 11.3098L13.0291 7.09467Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRfqCheck);
export default __webpack_public_path__ + "static/media/rfq-check.9221701187436f8e8007432399fd7b37.svg";
export { ForwardRef as ReactComponent };